import { createSelector } from '@ngrx/store';
import { Seq } from 'immutable';
import { selectAllMedicalControlContactLogEntries } from 'src/store/entityStores/entity-store-selectors';
import { MedicalControlContactLogEntryRecord } from '../generated/medical-control-contact-log-entry-record.generated';

export function selectMedicalControlContactLogEntryById(id: string) {
  return createSelector(
    selectAllMedicalControlContactLogEntries,
    (medicalControlContactLogEntries) => {
      return medicalControlContactLogEntries.get(id);
    },
  );
}

export function selectMedicalControlContactLogEntriesByCardId(cardId: string) {
  return createSelector(
    selectAllMedicalControlContactLogEntries,
    (medicalControlContactLogEntries) => {
      return cardId == null
        ? Seq.Indexed<MedicalControlContactLogEntryRecord>()
        : medicalControlContactLogEntries
            .filter((logEntry) => logEntry.cardId === cardId)
            .toIndexedSeq();
    },
  );
}
